import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';
import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-map-export',
  templateUrl: './map-export.component.html',
  styleUrl: './map-export.component.scss',
  standalone: false,
})
export class MapExportComponent extends BaseComponent implements OnInit {
  public menuItems: MenuItem[] = [];

  constructor(protected toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
  }

  ngOnInit(): void {
    this.initializeMenuItems();
  }

  private initializeMenuItems(): void {
    this.menuItems = [
      {
        label: 'Export Image',
        icon: 'pi pi-images',
        command: () => this.onExportPNG(),
      },
    ];
  }

  public onExportPNG(): void {
    this.toolbarEventManagerHelper.MapToolbarExportPng = true;
  }
}
